import { get } from 'lodash';
// import { convertHexToRGB } from '../../../../utils';

const styles = ({ color, typography, fontSize, padding, margin }) => ({
  applicationLink: {
    display: 'table',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '50px',
  },
  btnLabel: {
    height: 21,
  },
  btnRoot: {
    color: get(color, 'link'),
    fontFamily: get(typography, 'bodyText'),
    fontSize: get(fontSize, 'bodyText'),
    height: 21,
    padding: '0 0',
    margin: '0 0',
  },
  collapse: {
    width: '100%',
  },
  selectionContainer: {
    border: `1px solid ${get(color, 'borderColor')}`,
    marginTop: 0,
    padding: '0 24px',
    paddingBottom: 40,
  },
  selectionDropdown: {
    marginTop: '12px !important',
  },
  filterContainer: {
    paddingRight: '10px',
  },
  apiContainer: {
    borderRight: `1px solid ${get(color, 'borderColor')}`,
    '& .MuiGrid-root': {
      marginLeft: '0px',
      marginRight: '0px',
    },
    '& thead': {
      display: 'none !important',
    },
    '& nav': {
      display: 'none !important',
    },
    '& .MuiTablePagination-caption': {
      display: 'none !important',
    },
    '& .MuiTablePagination-selectRoot': {
      display: 'none !important',
    },
    '& .MuiTableCell-root' : {
      cursor: 'pointer',
      paddingLeft: `${get(padding, 'p20')} !important`,
    },
  },
  pageBodyClass: {
    paddingTop: get(padding, 'p0'),
  },
  pageFilterAndSortClass: {
    marginTop: get(margin, 'm0'),
    padding: 0,
    margin: '0 6px 0 6px',
  },
  fieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
    marginRight: '5px !important',
    marginLeft: '15px !important',
    width: '100%',
  },
  cancelButton: {
    textTransform: 'none',
    color: get(color, 'primaryButtonBackground'),
    backgroundColor: get(color, 'primaryButtonText'),
    borderColor: get(color, 'primaryButtonBackground'),
    lineHeight: get(color, 'lineHeight.lh20'),
    '&:focus': {
      outlineOffset: "1px",
      outline: `1px double ${get(color, 'primaryButtonBackground')}`,
    },
  },
  apiDetailsContainer: {
    marginTop: get(margin, 'm20'),
    borderBottom: `1px solid ${get(color, 'borderColor')}`,
    paddingLeft: get(padding, 'p20'),
    paddingBottom: get(padding, 'p20'),
  },
  authDetailsContainer: {
    paddingLeft: get(padding, 'p20'),
  },
  swaggerContainer: {
    paddingLeft: get(padding, 'p20'),
  },
  appContainer: {
    paddingLeft: get(padding, 'p20'),
    paddingRight: get(padding, 'p20'),
    borderBottom: `1px solid ${get(color, 'borderColor')}`,
    paddingBottom: get(padding, 'p20'),
  },
  headerNameContainer: {
    marginRight: get(margin, 'm60'),
  },
  headerContainer: {
    marginRight: get(margin, 'm20'),
  },
  assestPopOverContainer: {
    '& .MuiPopover-paper': {
      top: '270px !important',
      left: '400px !important',
      width: '400px',
      paddingRight: get(padding, 'p20'),
    },
  },
  descriptionPopOverContainer: {
    '& .MuiPopover-paper': {
      top: '270px !important',
      left: '600px !important',
      width: '400px',
      padding: get(padding, 'p20'),
      minHeight: '100px',
    },
  },
});

export default styles;
